import * as React from "react";
import { I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import Heading from "../Heading";
import PanelFrequentlyVisited from "../panel/PanelFrequentlyVisited";
import PanelMainDataCategories from "../panel/PanelMainDataCategories";
import PanelInfographics from "../panel/PanelInfographics";
import PanelSearch from "../panel/PanelSearch";
import PanelUpdates from "../panel/PanelUpdates";
import Throbber from "../Throbber";
import "./PageHome.css";


class PageHome extends React.Component<any, any> {
    render() {
        return (
            <div className="page-home">
                <Heading
                    className="page-home-heading"
                    description={I18n.t("frontend_page_home_heading_description")}
                    title={I18n.t("frontend_text_NationalSocialCareDataPortalForWales")}
                />

                <PanelInfographics groupId="page-home"/>

                <PanelSearch />

                <div className="page-home-section">
                    <div className="panel-container-updates-frequently-visited">
                        <div className="panel-container-updates">
                            <PanelUpdates />
                        </div>

                        <div className="panel-container-frequently-visited">
                            <PanelFrequentlyVisited />
                        </div>
                    </div>

                    <PanelMainDataCategories />
                </div>
            </div>
        );
    }
}

// Link with Redux store

const mapStateToProps =
    (state: any) => ({
        locale: state.i18n.locale
    });

export default connect(mapStateToProps)(PageHome);